import { ISODateTimeString } from "@buzzeasy/shared-frontend-utilities";
import { createApi } from "@reduxjs/toolkit/query/react";
import { apiBaseQuery, post } from "../helpers";

const campaignManagerApi = createApi({
  reducerPath: "campaignManager",
  tagTypes: [],
  baseQuery: apiBaseQuery("/v1/campaigns"),
  endpoints: builder => ({
    getCampaignsExistForTenant: builder.query<boolean, void>({
      query: () => "/exists",
      transformResponse: (response: { exists: boolean }) => response.exists,
    }),
    getFutureScheduledRecords: builder.query<PagedResult<FutureScheduledRecordResponse>, GetFutureScheduledRecordsRequest>({
      query: params => post("/future-scheduled-records", params),
    }),
  }),
});

export const {
  useGetCampaignsExistForTenantQuery,
  useGetFutureScheduledRecordsQuery,
} = campaignManagerApi;

export default campaignManagerApi;

interface PagedResult<T> {
  total: number;
  results: T[];
}

export interface GetFutureScheduledRecordsRequest {
  fromDate: ISODateTimeString;
  toDate: ISODateTimeString;
  skip: number;
  top: number;
}

export interface FutureScheduledRecordResponse {
  id: string;
  status: unknown;
  scheduleAfter: ISODateTimeString;
  isSuspended: boolean;
  customerName: string;
  phoneNumbers: {
    number: string;
    tag: string | null;
    color: string | null;
  }[];
  campaign: {
    name: string;
    type: "Preview" | "Callback" | "Predictive" | "FlowControlled";
    status: "Running" | "Stopped";
  };
}
